<template>
  <div>
    <section class="layout layout--auth">
      <auth-select-lang />
      <div class="container">
        <div class="auth-content col-5">
          <div class="auth-content__logo">
            <a href="https://zorra.com">
              <img src="/img/logo_with_name.png" alt="Логотип Zorra" />
            </a>
          </div>
          <div class="auth-content__form">
            <router-view />
          </div>
        </div>
      </div>
      <div class="b-captcha-text" v-html="$t('core.dashboard.captcha')"></div>
      <messangers-component />
    </section>
  </div>
</template>

<script>
  import AuthSelectLang from '@core/components/auth/auth-select-lang';
  import MessangersComponent from '@shared/components/layout-default/layout-default-messangers';
  export default {
    components: {
      AuthSelectLang,
      MessangersComponent
    }
  };
</script>

<style lang="scss">
  .layout--auth {
    display: flex;
    flex-direction: column;

    .b-captcha-text {
      color: #fff;
      font-family: 'Lato', 'sans-serif';
      font-size: 14px;
      line-height: 22px;
      align-self: center;
      text-align: center;
      margin-top: auto;
    }
  }
</style>
